// // import React from 'react';
// // import Sidebar from '../Sidebar/Sidebar';
// // import Header from '../Header/Header';
// // import './Layout.css';

// // const Layout = ({ children }) => {
// //   return (
// //     <div className="layout-container">
// //       <Sidebar />
// //       <div className="main-content">
// //         <Header />
// //         <div className="content-body">
// //           {children}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Layout;

// import React, { useState } from 'react';
// import Sidebar from '../Sidebar/Sidebar';
// import Header from '../Header/Header';
// import './Layout.css';

// const Layout = ({ children }) => {
//   // 1. Manage Sidebar State here so it persists
//   const [isCollapsed, setIsCollapsed] = useState(false);

//   const toggleCollapse = () => {
//     setIsCollapsed(!isCollapsed);
//   };

//   return (
//     <div className={`layout-container ${isCollapsed ? 'collapsed' : ''}`}>
//       {/* 2. Pass state and toggle function to Sidebar */}
//       <Sidebar isCollapsed={isCollapsed} toggleCollapse={toggleCollapse} />

//       <div className="main-content">
//         {/* Pass toggle to Header if your hamburger menu is there */}
//         <Header toggleSidebar={toggleCollapse} />

//         <div className="content-body">
//           {children}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Layout;

import React, { useState, useEffect, useCallback } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import Header from '../Header/Header';
import './Layout.css';

const Layout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

  // Handle window resize for responsive behavior
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 992;
      setIsMobile(mobile);
      // Close mobile menu when switching to desktop
      if (!mobile && isMobileOpen) {
        setIsMobileOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMobileOpen]);

  // Close mobile sidebar when clicking overlay
  const closeMobileSidebar = useCallback(() => {
    setIsMobileOpen(false);
  }, []);

  // Toggle for desktop collapse
  const toggleCollapse = useCallback(() => {
    setIsCollapsed(prev => !prev);
  }, []);

  // Toggle for mobile sidebar
  const toggleMobileSidebar = useCallback(() => {
    setIsMobileOpen(prev => !prev);
  }, []);

  // Close mobile sidebar on route change
  useEffect(() => {
    if (isMobile && isMobileOpen) {
      // Adding listener for any click inside sidebar that triggers navigation
      const handleNavigation = () => {
        setIsMobileOpen(false);
      };

      // This will be handled by menu clicks
      return () => { };
    }
  }, [isMobile, isMobileOpen]);

  return (
    <div className={`layout-container ${isCollapsed ? 'collapsed' : ''}`}>
      {/* Mobile overlay backdrop */}
      {isMobile && (
        <div
          className={`sidebar-overlay ${isMobileOpen ? 'active' : ''}`}
          onClick={closeMobileSidebar}
          style={{ display: isMobileOpen ? 'block' : 'none' }}
        />
      )}

      {/* Sidebar with mobile support */}
      <Sidebar
        isCollapsed={isCollapsed}
        toggleCollapse={toggleCollapse}
        isMobileOpen={isMobileOpen}
        closeMobileSidebar={closeMobileSidebar}
      />

      <div className="main-content">
        {/* Header with hamburger menu toggle */}
        <Header
          toggleMobileSidebar={toggleMobileSidebar}
          isMobile={isMobile}
        />

        <div className="content-body fade-in">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;